export default __webpack_public_path__ + "static/media/hero-bg-2.572211b2.webp";